import { TableCell, TableRow } from '@/shared/components/shadcn/table';

import { toScrapingRunViewModel } from '../../model/scraping-run-view-model';
import { type ScrapingRunSummary } from '../../types';
import { ScrapingStatusBadge } from '../../ui/scraping-status-badge';
import { ScrapingRunActions } from './scraping-run-actions';

type ScrapingRunRowProps = {
  run: ScrapingRunSummary;
  intent_id: string;
};

export function ScrapingRunRow({ run, intent_id }: ScrapingRunRowProps) {
  const viewModel = toScrapingRunViewModel(run);

  return (
    <TableRow gridTemplateColumns="minmax(140px,1fr) minmax(150px,1fr) minmax(150px,1fr) minmax(220px,1.5fr)">
      <TableCell>{viewModel.executionDate}</TableCell>
      <TableCell>
        <ScrapingStatusBadge label={viewModel.statusLabel} tone={viewModel.tone} />
      </TableCell>
      <TableCell>{viewModel.createdAt}</TableCell>
      <TableCell>
        <ScrapingRunActions run={run} intent_id={intent_id} />
      </TableCell>
    </TableRow>
  );
}
